// extracted by mini-css-extract-plugin
export default {"Message":"Message_Message__8pQCj","orange":"Message_orange__oYkVP"};